import axios from '@/shared/axios';
import type { paths } from '@/schemas/api';

export type SendCaptchaType = DefineService<paths, '/login/code/req'>;
export function sendCaptcha(params: SendCaptchaType['Params']) {
  return axios.post<SendCaptchaType['Result']>('/login/code/req', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export type LoginType = DefineService<paths, '/clientInfo/signIn'>;
export function login(params: LoginType['Params']) {
  return axios.post<LoginType['Result']>('/clientInfo/signIn', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export type QueryCaptchaByPhoneType = {
  Params: {
    mobileNumber: string;
    appTitle: string;
  };
};
export function queryCaptchaByPhone(params: QueryCaptchaByPhoneType['Params']) {
  return axios.post('/clientAccess/abort/webApp/authCheck/scriptCode', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function checkH5VerifyCodeAndSignOut(params: {
  mobileNumber: string;
  authToken: string;
  appTitle: string;
}) {
  return axios.post('/clientData/revokeAction/webApp/carryOut', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryAgreement(params: any) {
  return axios.post('/mutualPact/tailorMade', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}

export function queryDownloadType(params: any) {
  return axios.post('/app/download/methods', params, {
    __interceptorOptions__: {
      security: true,
    },
  });
}
